import './Faq.scss'
import React from 'react'
import { inject, observer } from 'mobx-react'
import RootStore from '../../stores/RootStore'
import { WrappedComponentProps, injectIntl } from 'react-intl'
import { RouteComponentProps, withRouter } from 'react-router'

import {
	Elements,
	CloseButton,
	ExpandingSection,
	ReportTable,
} from '@tfo/common'

export interface IFaqProps {
	rootStore?: RootStore
}
const { Paragraph } = Elements

const Faq = (
	props: React.FunctionComponent &
		IFaqProps &
		WrappedComponentProps &
		RouteComponentProps,
) => {
	const { intl } = props
	const store = props.rootStore

	return (
		<React.Fragment>
			<div className="IndividualContainerOverlay">
				<div className="Faq">
					<div className="Faq__Header">
						<h1>{intl.formatMessage({ id: 'faq.container.heading' })}</h1>
						<CloseButton
							className="Faq__Header__Close"
							onClick={store.goBack}
						/>
					</div>
					<div className="Faq__Body">
						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.backgroundSearchWhatTFOdo',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.backgroundSearchWhatTFODo.1',
									})}
									<br /> <br />
									{intl.formatMessage({
										id: 'faq.paragraph.backgroundSearchWhatTFODo.2',
									})}
									<br /> <br />
									{intl.formatMessage({
										id: 'faq.paragraph.backgroundSearchWhatTFODo.3',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.mailAboutCreditReport',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.mailAboutCreditReport.1',
									})}
									<br /> <br />
									{intl.formatMessage({
										id: 'faq.paragraph.mailAboutCreditReport.2',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.whyBackgroundSearch',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.whyBackgroundSearch',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({ id: 'faq.title.turnDownSearch' })}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({ id: 'faq.paragraph.turnDownSearch' })}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.backgroundSearchOnMyself',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.backgroundSearchOnMyself',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({ id: 'faq.title.WhenRapportDone' })}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({ id: 'faq.paragraph.WhenRapportDone' })}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>
						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.ifTFOFindSomething',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.ifTFOFindSomething',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.doesIndividualSeeTheBackgroundSearch',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.doesIndividualSeeTheBackgroundSearch',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.whyDoesAnotherCompanyBackgroundSearch',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.whyDoesAnotherCompanyBackgroundSearch',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.didnotGetJobBecauseOfBackgroundsearch',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.didnotGetJobBecauseOfBackgroundsearch',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.howOldInformationCanTFOFind',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.howOldInformationCanTFOFind',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.whatIFIndividualKnowPaymentDefault',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.whatIFIndividualKnowPaymentDefault',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.whoIsTheBackgroundsearchOn',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.whoIsTheBackgroundsearchOn',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.canIndividualDirectSeeWhenSomethingFound',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.canIndividualDirectSeeWhenSomethingFound',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.whyNotJustCriminalRecord',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.whyNotJustCriminalRecord',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.isBackgroundsearchSameAsCriminalRecord',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.isBackgroundsearchSameAsCriminalRecord',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.whatsTheLinkToTheSurveyAbout',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.whatsTheLinkToTheSurveyAbout',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.doesTFOgoogleTheIndividual',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.doesTFOgoogleTheIndividual',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.whatsTFOsSources',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.whatsTFOsSources.1',
									})}
									<br /> <br />
									{intl.formatMessage({
										id: 'faq.paragraph.whatsTFOsSources.2',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.doIndividualGetCopyAndIfSomethingWrong',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.doIndividualGetCopyAndIfSomethingWrong',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.whatSavesAndHowLong',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.whatSavesAndHowLong',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.IndividualsRightByGDPR',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.IndividualsRightByGDPR',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.whatMeansCheckingReferend',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.whatMeansCheckingReferend',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>

						<ExpandingSection
							className="Faq__Body__ExpandingSection"
							caption={intl.formatMessage({
								id: 'faq.title.contactWithCurrentEmployer',
							})}>
							<ReportTable className="Faq__Body__Table">
								<Paragraph>
									{intl.formatMessage({
										id: 'faq.paragraph.contactWithCurrentEmployer',
									})}
								</Paragraph>
							</ReportTable>
						</ExpandingSection>
					</div>
					<hr />
					<div className="Faq__Footer">
						<h1>
							{' '}
							{intl.formatMessage({ id: 'faq.footer.heading.cannot.find' })}
						</h1>
						<Paragraph>
							{' '}
							{intl.formatMessage({ id: 'faq.footer.paragraph.info' })}{' '}
							<a href="mailto:info@tofindout.se">
								{' '}
								{intl.formatMessage({ id: 'faq.footer.e-post' })}
							</a>
							.
						</Paragraph>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}

export default withRouter(inject('rootStore')(injectIntl(observer(Faq))))
